/**
 * Groups tasks by their source campaign.
 * Returns array of { campaign, tasks } objects sorted by campaign name.
 */
export const groupTasksByCampaign = (tasks) => {
  const groups = {};

  tasks.forEach((task) => {
    const campaign = task.sourceCampaign;
    if (!campaign) {
      const fallbackId = 'unknown';
      if (!groups[fallbackId]) {
        groups[fallbackId] = {
          campaign: { id: fallbackId, name: 'Unknown', color: '#6b7280' },
          tasks: [],
        };
      }
      groups[fallbackId].tasks.push(task);
    } else {
      if (!groups[campaign.id]) {
        groups[campaign.id] = {
          campaign,
          tasks: [],
        };
      }
      groups[campaign.id].tasks.push(task);
    }
  });

  return Object.values(groups).sort((a, b) =>
    (a.campaign?.name || '').localeCompare(b.campaign?.name || '')
  );
};
